export default "__VITE_ASSET__nkzfASR0__"